import PropTypes from 'prop-types';
import { buildFileViewerUrl } from 'utils/urlUtils';
import './fileViewer.css';
import useConf from 'hook/useConf';
import { useGetConfigurationQuery } from 'services/applicationApi';

/**
 * FileViewer is a component that displays file content in an iframe using pdfjs.
 * The source URL for the iframe is built using the provided file content.
 * The file name is used as the title for the iframe.
 *
 * @component
 * @example
 * // Suppose fileContent is a Blob representing the file content and fileName is 'example.txt'
 * <FileViewer fileContent={fileContentBlob} fileName='example.txt' />
 *
 * @param {string} contentId - The content ID of the file to be displayed.
 * @param {string} fileName - The name of the file to be displayed.
 *
 * @returns {React.Component} The FileViewer component which displays the file content within an iframe.
 */
function FileViewer({ contentId, fileName }) {
  const { getValue: conf } = useConf(useGetConfigurationQuery);
  const pdfjsPreferences = conf('module.fileViewer.pdfjs');
  if (pdfjsPreferences != null) {
    localStorage.setItem('pdfjs.preferences', JSON.stringify(pdfjsPreferences));
  }

  return (
    <iframe
      id="fileViewerFrame"
      title={fileName}
      src={buildFileViewerUrl(contentId, localStorage.getItem('fileViewerSearchQuery'))}
      className="fileViewerFrame"
      allowFullScreen
    />
  );
}

FileViewer.propTypes = {
  contentId: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired
};
export default FileViewer;
